import classNames from 'classnames/bind';

export const cx = classNames.bind({
    selected: 'tab__selected',
    default: 'tab__default',
});
